import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { IMAGES } from "@/lib/constants";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue dans l'espace administrateur.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain min-h-screen flex items-center justify-center px-6 bg-theatre-ink" data-testid="admin-login-page">
      <div className="absolute inset-0 spotlight-glow" aria-hidden="true" />
      <div className="relative w-full max-w-md">
        <Link to="/" data-testid="login-back-link" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-theatre-gold transition-colors duration-200 mb-8">
          <ArrowLeft size={14} /> Retour au site
        </Link>

        <div className="bg-black/60 backdrop-blur-xl border border-theatre-gold/20 p-10">
          <div className="text-center mb-8">
            <img src={IMAGES.logo} alt="Viva Artist" className="h-14 w-14 object-contain mx-auto" />
            <h1 className="mt-4 font-serif text-2xl text-white">Espace Administrateur</h1>
            <p className="mt-2 text-sm text-neutral-500">Viva Artist · Gestion des candidatures</p>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-[0.2em] text-neutral-400">Email</Label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black/50 border-white/15 text-white focus-visible:ring-theatre-gold focus-visible:border-theatre-gold rounded-none h-12" />
            </div>
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-[0.2em] text-neutral-400">Mot de passe</Label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black/50 border-white/15 text-white focus-visible:ring-theatre-gold focus-visible:border-theatre-gold rounded-none h-12" />
            </div>
            <button type="submit" data-testid="login-submit" disabled={loading} className="w-full bg-theatre-red hover:bg-theatre-redhover disabled:opacity-60 text-white py-3.5 text-xs uppercase tracking-[0.25em] transition-colors duration-300 flex items-center justify-center gap-2">
              {loading && <Loader2 className="animate-spin" size={16} />}
              {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
